import React, { useState } from 'react'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'
import { Select, Row } from 'antd'
import { BlazeButton } from '../../../../../components/CustomButtons/BlazeButton'
import { IDevice, ILocation } from '@getgreenline/homi-shared'
import { isUndefined } from 'lodash'

interface Props {
  locations: ILocation[]
  devices: IDevice[]
  applyFilter: (locationIds: number, deviceIds: string[]) => void
}

const _ShiftFilter = (props: Props) => {
  const { locations, devices, applyFilter } = props

  const [selectedLocationId, setSelectedLocationId] = useState<number | undefined>()
  const [selectedDeviceIds, setSelectedDeviceIds] = useState<string[]>([])

  const devicesFromSelectedLocation = devices.filter(
    (device) => device.locationId === selectedLocationId,
  )

  const handleResetFilters = () => {
    setSelectedLocationId(undefined)
    setSelectedDeviceIds([])
  }

  const renderDeviceDropdownOptions = () => {
    if (isUndefined(selectedLocationId)) {
      return (
        <Select.Option key='all-none' value='' disabled>
          <div className='text-right w-100 mb-1 cursor-pointer'>
            <span className='text-muted'>Please select a location</span>
          </div>
        </Select.Option>
      )
    }

    return devicesFromSelectedLocation.map((device) => (
      <Select.Option key={device.id} value={device.id}>
        {device.deviceId}
      </Select.Option>
    ))
  }

  return (
    <div className='d-flex flex-wrap white-rounded-container pb-0'>
      <Select<number | undefined>
        className='gr-filter-item gr-filter-gutter'
        placeholder='Location'
        allowClear={true}
        dropdownMatchSelectWidth={false}
        value={selectedLocationId}
        onChange={(locationValue) => {
          if (locationValue !== selectedLocationId) {
            setSelectedDeviceIds([])
          }
          setSelectedLocationId(locationValue)
        }}
        showArrow={true}
      >
        {locations.map((location) => (
          <Select.Option key={location.id} value={location.id}>
            {location.name}
          </Select.Option>
        ))}
      </Select>
      <Select<string[] | undefined>
        className='gr-filter-item gr-filter-gutter'
        placeholder='Devices'
        allowClear={true}
        dropdownMatchSelectWidth={false}
        mode={'multiple'}
        value={selectedDeviceIds}
        onChange={(deviceValue) => setSelectedDeviceIds(deviceValue || [])}
        showArrow={true}
      >
        {renderDeviceDropdownOptions()}
      </Select>
      <Row className='gr-filter-gutter'>
        <BlazeButton
          buttonProps={{
            type: 'primary',
            onClick: () => {
              if (selectedLocationId) {
                applyFilter(selectedLocationId, selectedDeviceIds)
              }
            },
            disabled: !selectedLocationId,
          }}
          titleProps={{ title: 'Apply' }}
        />

        <BlazeButton
          buttonProps={{
            className: 'sgr-btn-ghost',
            type: 'link',
            onClick: handleResetFilters,
          }}
          titleProps={{ title: 'Reset' }}
        />
      </Row>
    </div>
  )
}

export const ShiftFilter = inject('currentCompanyStore')(observer(_ShiftFilter))
